import mbFetch from "mibaby-common/util/fetch";
import { unmountComponentAtNode } from "react-dom";

const UPLOAD_URL = import.meta.env.REACT_FORM_UPLOAD_URL || "/forms/upload";

function ensureProps(cur) {
    if (cur.type === "object") {
        if (!cur.properties) cur.properties = {};
        Object.keys(cur.properties).forEach(k => ensureProps(cur.properties[k]));
    }
}

const updater = id => (state, newObj) => ({
    ...state,
    [id]: { ...state[id], ...newObj },
});

const loadSuccessRow = (targetId, rowId, lpId) => {
    jQuery.get(`/static_contents/row/${rowId}?lp=${lpId}`).then(html => {
        const target = document.getElementById(targetId);
        console.log(target);
        unmountComponentAtNode(target);
        jQuery(target).closest(".sc-row-container-wrapper").replaceWith(html).trigger("newContent").get(0).scrollIntoView();
    });
};

export const reducer = (state = {}, { type, ...data }) => {
    const update = updater(data.id);

    switch (type) {
        case "dynamic_forms/submit":
            return update(state, { status: "submitting" });
        case "dynamic_forms/error":
            return update(state, { status: "error", serverError: data.error });
        case "dynamic_forms/submitted":
            const { fbPixel, fbPixelTriggered } = state[data.id];

            if (fbPixel && window._fbq && !fbPixelTriggered) {
                window._fbq.push(["track", fbPixel.event, fbPixel.data]);
                state = update(state, { fbPixelTriggered: true });
            }

            if (data.next) {
                data.next();
                state = update(state, { status: null });
            } else if (data.successPage) {
                setTimeout(() => (document.location = data.successPage), 100);
            } else {
                const { lp, sr } = state[data.id];
                loadSuccessRow(data.id, sr, lp);
            }

            return state;

        default:
            Object.keys(state).forEach(k => {
                ensureProps(state[k].schema);
            });
    }
    return state;
};

export const submitLeadForm =
    ({ id, formData }, next) =>
    async (dispatch, getState) => {
        dispatch({ type: "dynamic_forms/submit", id });

        const { apiKey, successPage = null } = getState().forms[id];

        try {
            const response = await mbFetch("/forms/dynamic_form", {
                method: "POST",
                body: JSON.stringify({ apiKey, formData }),
            });

            if (!response.ok) {
                throw new Error(`Status ${response.status}. ${response.statusText}`);
            }

            const json = await response.json();

            if (json.error) {
                throw new ServerResponseError("Server Fehler", json.error);
            }

            dispatch({ type: "dynamic_forms/submitted", id, next, successPage });
        } catch (error) {
            if (process.env.NODE_ENV === "development") {
                console.error(error);
            }

            dispatch({
                type: "dynamic_forms/error",
                error: error instanceof ServerResponseError ? error.data : "Ups... Da ist was schief gelaufen!",
                id,
            });
        }
    };

export const uploadFile =
    ({ id, file }) =>
    async (_dispatch, getState) => {
        const { apiKey } = getState().forms[id];

        const data = new FormData();
        data.append("apiKey", apiKey);
        data.append("qqfile", file);
        const req = await fetch(UPLOAD_URL, { method: "POST", body: data });

        let resp;
        try {
            resp = await req.json();
        } catch (e) {
            console.error(e);
            resp = {};
        }

        return resp;
    };

class ServerResponseError extends Error {
    constructor(error, data) {
        super();
        this.data = data;
    }
}
